import { cx } from '@linaria/core';
import { flex } from 'styles/utils';

export const UploadAreaStyles = cx(flex.init, flex.direction.column);
